import Vue from 'vue'

//Load all icons in folder (Webpack)
var req = require.context('@/assets/icons', true, /^.*\.icon.svg$/i);
req.keys().forEach(function(key){
  req(key);
});

export default Vue.component('Icon', {
  template: '<svg class="svg-icon" :name="name.replace(/\\./g, \'-\')"><use :xlink:href="\'#\' + name + \'.icon\'"></use></svg>',
  props: ['name'],
});


// WEBPACK FOOTER //
// ./src/providers/svgicons.js